import * as React from "react";

export const useFirstClickAd = (enabled, adUrl) => {
  const [clicked, setClicked] = React.useState(false);

  React.useEffect(() => {
    if (!enabled || clicked) return;

    // Check if already clicked in this session
    const alreadyClicked = sessionStorage.getItem('firstClickAdShown');
    if (alreadyClicked) {
      setClicked(true);
      return;
    }

    const handleClick = (e) => {
      // Don't intercept if clicking on a link or button that should navigate
      const target = e.target;
      const isInteractive = target.closest('a[href^="http"]') || 
                           target.closest('button[type="submit"]') ||
                           target.closest('[data-no-ad-intercept]');
      
      if (isInteractive) return;

      // Mark as clicked
      sessionStorage.setItem('firstClickAdShown', 'true');
      setClicked(true);

      // Open ad in new tab
      if (adUrl) {
        window.open(adUrl, '_blank');
      }
    };

    // Add click listener
    document.addEventListener('click', handleClick, { once: true });

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [enabled, adUrl, clicked]);

  return clicked;
};
